export const accountTypeValues = {
  business: 'business',
  consumer: 'consumer',
};
